import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { DataRoomLenderSummaryReport, Guid } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useLenderSummaryReportQuery(
	dataRoomGuid?: Guid | undefined,
	options?:
		| Omit<
				UseQueryOptions<DataRoomLenderSummaryReport, unknown, DataRoomLenderSummaryReport, any>,
				'queryKey' | 'queryFn'
		  >
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.DataRoom.LenderSummaryReport(dataRoomGuid),
		() =>
			AxiosUtils.getResponseData<DataRoomLenderSummaryReport>(
				api.get(CerebroApiEndpoints.DataRooms.LenderSummaryReport(dataRoomGuid))
			),
		options
	);
}
